import { useGetFeatureCatalogQuery } from "@/store/rest_api";
import type { FeatureKey } from "@/model/interface/Feature";

export function useFeature(
  feature: FeatureKey,
  { refetchOnMount = false }: { refetchOnMount?: boolean } = {},
): boolean {
  const { data } = useGetFeatureCatalogQuery(undefined, { refetchOnMountOrArgChange: refetchOnMount });
  const entry = data?.find((f) => f.key === feature);
  return entry?.enabled === true;
}

export function useFeatures(features: FeatureKey[]): Record<FeatureKey, boolean> {
  const { data } = useGetFeatureCatalogQuery();
  const result = {} as Record<FeatureKey, boolean>;
  for (const key of features) {
    result[key] = data?.find((f) => f.key === key)?.enabled === true;
  }
  return result;
}
